import {
  VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST,
  VERIFY_PVS_REGISTRATION_PAYMENT_SUCCESS,
  VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE,
  VERIFY_PVS_REGISTRATION_PAYMENT_RESET,
} from "../../../types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const verifyPvsRegistrationPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case VERIFY_PVS_REGISTRATION_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message:
          (action.payload && action.payload.message) ||
          "PVS registration verified successfully",
      }

    case VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload && action.payload.message,
      }

    case VERIFY_PVS_REGISTRATION_PAYMENT_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default verifyPvsRegistrationPaymentReducer
